// extracted by mini-css-extract-plugin
export default {"root":"ProductHistoryDialog_root__OJMzf","filters":"ProductHistoryDialog_filters__XXDxC"};